import * as React from 'react';

import { AccordionItem, AccordionItemContent } from './AccordionItem';

interface Props {
  items: AccordionItemContent[];
}

export const AccordionList = ({ items }: Props) => {
  return (
    <ul className="c-accordion">
      {items.map((item) => (
        <AccordionItem key={item.header} item={item} />
      ))}
    </ul>
  );
};
